import React from 'react'

import { Button, Empty, Typography } from 'antd';
export default function NoContentBox(props) {
	return (
		<Empty description={props.text} image={Empty.PRESENTED_IMAGE_SIMPLE} />
	)
}
